<template>
    <div class="d-flex flex-row m-0 item-style">
        <div class="col d-flex flex-column">
            <KeyValueCell horizontal inline-view :value="scheduledData[itemPos.locationId].workCenterName">工作中心</KeyValueCell>
            <KeyValueCell horizontal inline-view
                          :value="itemData.startTime.substring(0,5) + '-' + itemData.finishTime.substring(0,5)">
                工作时间
            </KeyValueCell>
            <KeyValueCell horizontal :value="itemData.workingHoursAbility+'H'">班次能力</KeyValueCell>
            <KeyValueCell horizontal :value="itemData.workingHoursActual+'H'">负载总计</KeyValueCell>
            <div class="colored-title text-center"
                 :class="itemData.workingHoursActual > itemData.workingHoursAbility ? 'cl-red' : 'cl-green'">
                {{ loadRate }}%
            </div>
        </div>
        <div class="col">
            <div class="cell-cover d-flex flex-row" id="scrollbar">
                <div class="cell border h-100" v-for="(item,index) in opPosList" :key="index"
                     :style="'width: ' + item.posForecastWorkHour * 100 / itemData.workingHoursActual + '%'"
                     @click="selectOperation(item)">
                    <div class="at-center">
                        <div class="d-flex flex-wrap">
                            <div class="colored-title"
                                 :class="item.posIdOperation===selectedOperationId?'cl-purple':'text-dark'">
                                {{ item.posForecastWorkHour }}H
                            </div>
                            <div class="mt-auto mb-auto ml-1" v-if="operationMap[item.posIdOperation].isLocked">
                                <i class="fa fa-lock text-info" aria-hidden="true"></i>
                            </div>
                            <div class="mt-auto mb-auto ml-1"
                                 v-if="operationMap[item.posIdOperation].missionMode!==undefined">
                                <i class="fa text-info"
                                   :class="operationMap[item.posIdOperation].missionMode===1 ? 'fa-cogs' : 'fa-hand-paper-o'"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <empty-list-info v-if="itemData.workingHoursActual===0"></empty-list-info>
            </div>
        </div>

        <div class="col d-flex flex-column" v-if="posData!=null">
            <KeyValueCell horizontal :value="posData.posSeq+''">子工序序号</KeyValueCell>
            <KeyValueCell horizontal inline-view :value="posData.posForecastBeginTime">计划开始</KeyValueCell>
            <KeyValueCell horizontal inline-view :value="posData.posForecastEndTime">计划结束</KeyValueCell>
        </div>

        <div class="col d-flex flex-column pr-0" style="max-width: max-content">
            <AvatarButton :icon="displayMode===4?'el-icon-open':'el-icon-turn-off'"
                          @btnClick="switchDisplayModeBetweenLocks" title="显示锁定"></AvatarButton>
            <div v-if="selectedOperationId!==''">
                <AvatarButton v-if="!operationMap[selectedOperationId].isLocked" icon="el-icon-lock"
                              @btnClick="lockEvent(true)"
                              :loading="lockEventWaiting"
                              title="锁定"></AvatarButton>
                <AvatarButton v-if="operationMap[selectedOperationId].isLocked" icon="el-icon-unlock"
                              @btnClick="lockEvent(false)"
                              :loading="lockEventWaiting"
                              title="解锁"></AvatarButton>
            </div>
        </div>

        <div class="col d-flex flex-column align-items-start" v-if="selectedOperationId!==''"
             style="max-width: max-content">
            <AvatarButton icon="el-icon-coordinate" @btnClick="selectPos" title="标选目标点"></AvatarButton>
            <AvatarButton icon="el-icon-edit" @btnClick="openForm" title="输入目标信息"></AvatarButton>
            <AvatarButton icon="el-icon-check" @btnClick="submitChange" title="提交"
                          class="mt-auto"
                          :visible="submitVisible"
                          :loading="submitWaiting"></AvatarButton>
        </div>

        <div class="col d-flex flex-column" v-if="formVisible">
            <el-date-picker
                v-model="targetDate"
                type="datetime"
                placeholder="计划开始时间">
            </el-date-picker>
            <el-cascader
                filterable
                clearable
                placeholder="目标工作中心" class="mt-auto"
                v-model="targetLocationId"
                :options="locationList"
                :props="{ expandTrigger: 'hover' }">
            </el-cascader>
        </div>

        <button type="button"
                class="close position-absolute right-top"
                @click="cancel"
                aria-label="关闭">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
</template>

<script>
import KeyValueCell from "@/views/sithMes/prd/PrdOperationExcute/cells/KeyValueCell";
import {subMapOf} from "@/components/echarts-part/CalendarShift/cells/utils/LoadRateUtil";
import "@/components/echarts-part/CalendarShift/cells/stuffs/fade_color.css";
import {mapState} from "vuex";
import EmCommonApi from "@/mixin/em/common/api";
import moment from "moment";
import AvatarButton from "@/components/echarts-part/CalendarShift/cells/stuffs/AvatarButton";
import EmptyListInfo from "@/components/echarts-part/CalendarShift/cells/stuffs/EmptyListInfo";

export default {
    name: "LoadRateItem",
    components: {EmptyListInfo, AvatarButton, KeyValueCell},
    mixins: [EmCommonApi],
    data() {
        return {
            targetDate: null,
            targetLocationId: [],
            formVisible: false,
            posData: null,
            submitWaiting: false,
            lockEventWaiting: false,
        }
    },
    computed: {
        ...mapState({
            itemPos: state => state.calendarShift.itemPos,
            selectedOperationId: state => state.calendarShift.selectedOperationId,
            targetPos: state => state.calendarShift.targetPos,
            locationList: state => state.calendarShift.locationList,
            displayMode: state => state.calendarShift.displayMode,
            lockEventHappened: state => state.calendarShift.lockEventHappened,
        }),
        itemData() {
            return this.$store.getters["calendarShift/posData"](this.itemPos);
        },
        opPosList() {
            return subMapOf(this.itemData);
        },
        scheduledData() {
            return this.$store.getters["calendarShift/scheduledData"];
        },
        submitVisible() {
            return this.targetDate !== null || this.targetLocationId.length > 0;
        },
        loadRate() {
            return (this.itemData.workingHoursActual * 100 / this.itemData.workingHoursAbility).toFixed(0);
        },
        operationMap() {
            return this.$store.getters["calendarShift/operationMap"];
        },
        remoteData() {
            return this.$store.getters["calendarShift/scheduledData"];
        },
    },
    watch: {
        itemPos: {
            deep: true,
            immediate: true,
            handler(val, oldVal) {
                if (val != null && (oldVal == null || oldVal.locationId !== val.locationId || oldVal.dateStr !== val.dateStr)) {
                    if (this.opPosList != null && this.opPosList.length > 0) {
                        let has = false;
                        if (this.selectedOperationId !== '' && this.selectedOperationId != null) {
                            for (let item of this.opPosList) {
                                if (item.posIdOperation === this.selectedOperationId) {
                                    this.posData = item;
                                    has = true;
                                    break;
                                }
                            }
                        }
                        if (!has) {
                            this.posData = this.opPosList[0];
                        }
                    } else {
                        this.posData = null;
                        this.formVisible = false;
                    }
                }
            }
        },
        formVisible() {
            if (!this.formVisible) {
                this.targetLocationId = [];
                this.targetDate = null;
            }
        },
        targetPos(val) {
            if (val !== null) {
                this.targetLocationId = Array.of(this.remoteData[val.locationId].workCenterId + '', val.locationId);
                this.targetDate = val.dateStr;
                this.formVisible = true;
                this.$store.commit('calendarShift/setDisplayMode', 0);
                this.$store.commit('calendarShift/setTargetPos', null);
            }
        }
    },
    mounted() {
        this.addElementListeners();
    },
    beforeDestroy() {
        this.$store.dispatch('calendarShift/selectOperation', '');
    },
    methods: {
        cancel() {
            this.$store.commit('calendarShift/setItemOff', true);
        },
        selectOperation(op) {
            this.posData = op;
            this.$store.commit('calendarShift/setNeedScrollToHeader', true);
            this.$store.dispatch('calendarShift/selectOperation', op.posIdOperation);
        },
        openForm() {
            if (this.selectedOperationId !== '') {
                this.formVisible = true;
            }
        },
        selectPos() {
            this.$store.commit('calendarShift/setDisplayMode', this.$store.state.calendarShift.displayMode === 3 ? 0 : 3);
        },
        hasOperationId() {
            if (this.selectedOperationId == null || this.selectedOperationId === '') {
                this.$message.error('请先选择要调整的工序');
                return false;
            }
            return true;
        },
        submitChange() {
            if (this.hasOperationId()) {
                this.submitWaiting = true;
                let _api = this.$store.state.sithMesPrdPpOperation.baseModuleUrl +
                    "/sithMesPrdPpOperation/forecast-begin-time-adjust";
                let requestBody = {};
                requestBody.operationId = this.selectedOperationId;
                if (this.targetDate !== null) {
                    requestBody.forecastBeginTime = moment(this.targetDate).format(
                        this.$t("em.datetime.format.viewMode")
                    );
                }
                if (this.targetLocationId.length > 0) {
                    requestBody.actualLocationId = Number.parseInt(this.targetLocationId[this.targetLocationId.length - 1]);
                }
                this.$_emApiMixin_post(_api, requestBody).then(() => {
                    this.submitWaiting = false;
                    this.$message.success('调整成功，重新排产中');
                    this.emitEvent();
                }).catch(() => {
                    this.submitWaiting = false;
                });
            }
        },
        emitEvent() {
            this.$emit('needRefresh');
        },
        switchDisplayModeBetweenLocks() {
            this.$store.commit('calendarShift/setDisplayMode', this.displayMode === 4 ? 0 : 4);
        },

        lockEvent(isLock) {
            if (this.hasOperationId()) {
                this.lockEventWaiting = true;
                let _api = this.$store.state.sithMesPrdPpOperation.baseModuleUrl +
                    "/sithMesPrdPpOperation/" + (isLock ? 'lock' : 'unlock') + "?ids=" + this.selectedOperationId;
                this.$_emApiMixin_post(_api).then(() => {
                    this.afterLockEvent(isLock);
                });
            }
        },
        afterLockEvent(isLock) {
            this.lockEventWaiting = false;
            this.$message.success(isLock ? '锁定成功' : '解锁成功');
            this.$store.dispatch('calendarShift/changeLockStatus', {operationId: this.selectedOperationId, val: isLock})
        },
        addElementListeners() {
            let cell = document.getElementById("scrollbar");
            cell.addEventListener('wheel', (event) => {
                event.preventDefault();
                cell.scrollLeft += Number.parseFloat(event.deltaY + "");
            })
        }
    }
}
</script>

<style scoped>
.item-style {
    max-height: 120px;
}

.cell-cover {
    height: 100px;
    width: 350px;
    border-radius: 20px;
    overflow: hidden;
    margin: 0 auto 0 0;
    background-color: #ffffff;
}

.cell-cover:hover {
    overflow-x: auto;
}

#scrollbar::-webkit-scrollbar {
    height: 1px;
    background-color: transparent;
}

#scrollbar::-webkit-scrollbar-thumb {
    border-radius: 1px;
    background-color: gray;
}

.cell {
    min-width: min-content;
}

.cell:hover {
    background-color: #cb42f5;
}

.right-top {
    right: 0.6rem;
    top: 0.6rem;
}

.at-center {
    margin: 1rem;
}

.title {
    font-size: 0.6rem;
    color: #878787;
}

.colored-title {
    font-weight: bold;
    border-radius: 0.2rem;
    overflow: hidden;
    padding: 0 0.2rem;
    color: white;
}

.colored-title.cl-red, .cl-green {
    font-size: 1rem;
}

.colored-title.cl-purple, .text-dark {
    font-size: 0.8rem;
    min-width: max-content;
}

</style>